import Select from "react-select";
import { useTranslation } from "react-i18next";

const countries = [
	{
		value: "de",
		label: "Deutsch",
		country_code: "de",
	},
	{
		value: "en",
		label: "English",
		country_code: "gb",
	},
];

const customSingleValue = ({ data }) => (
	<div style={{ display: "flex", alignItems: "center" }}>
		<img
			src={`https://cdn.jsdelivr.net/npm/flag-icons/flags/4x3/${data.country_code}.svg`}
			alt={data.label}
			style={{ width: "1.5em", height: "1em", marginRight: "0.5em" }}
		/>
	</div>
);

const customOption = (props) => {
	const { data, innerRef, innerProps } = props;
	return (
		<div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "center", padding: "0.5em" }}>
			<img
				src={`https://cdn.jsdelivr.net/npm/flag-icons/flags/4x3/${data.country_code}.svg`}
				alt={data.label}
				style={{ width: "1.5em", height: "1em", marginRight: "0.5em" }}
			/>
		</div>
	);
};

const LanguageSelector = () => {
	const { i18n } = useTranslation();

	const handleChange = (selectedOption) => {
		i18n.changeLanguage(selectedOption.value);
	};

	return (
		<Select
			options={countries}
			defaultValue={countries.find((c) => c.value === i18n.language)}
			onChange={handleChange}
			isSearchable={false}
			components={{ SingleValue: customSingleValue, Option: customOption }}
			styles={{
				control: (base) => ({
					...base,
					backgroundColor: "#396393",
					color: "white",
				}),
				menu: (base) => ({
					...base,
					backgroundColor: "#396393",
					color: "white",
				}),
				singleValue: (base) => ({
					...base,
					color: "white",
				}),
				valueContainer: (provided) => ({
					...provided,
					paddingTop: 0,
					paddingBottom: 0,
					display: 'flex',
					alignItems: 'center',
				})
			}}
		/>
	);
};

export default LanguageSelector;
